import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    title: string;
    standardStorageLabel: string;
    triggerLabel: {
        /** Trigger label for storage type Mounted Storage (short label) */
        mounted: string;
        /** Trigger label for storage type Standard Storage (short label) */
        standard: string;
    };
    standardStorageDescription: string;
    mountedStorageLabel: string;
    mountedStorageDescription: string;
    upgradeError: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Setting title for mounted storage */
            title: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "MountedStorageTypeSelect.title?c=yj3wzunus7ws", defaultMessage: "Storage Type" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Label for storage type Standard Storage */
            standardStorageLabel: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "MountedStorageTypeSelect.standardStorageLabel?c=1ubl4e6foomg4", defaultMessage: "Standard Storage" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Trigger label for storage types (short label) */
            triggerLabel: {
                get() {
                    return Object.defineProperties({
                        [__intl__.BOUND_INTL]: this[__intl__.BOUND_INTL] ?? __intl__.getIntl()
                    }, {
                        /** Trigger label for storage type Mounted Storage (short label) */
                        mounted: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "MountedStorageTypeSelect.triggerLabel.mounted?c=2gzj8ht0f2k5p", defaultMessage: "Mounted" }));
                            },
                            enumerable: true,
                            configurable: true
                        },
                        /** Trigger label for storage type Standard Storage (short label) */
                        standard: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "MountedStorageTypeSelect.triggerLabel.standard?c=2871tdk5wm3mj", defaultMessage: "Standard" }));
                            },
                            enumerable: true,
                            configurable: true
                        }
                    });
                },
                enumerable: true,
                configurable: true
            },
            /** Description for storage type Standard Storage */
            standardStorageDescription: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "MountedStorageTypeSelect.standardStorageDescription?c=35lxkk4kk00v", defaultMessage: "Store this project in the cloud only and download to edit." }));
                },
                enumerable: true,
                configurable: true
            },
            /** Label for storage type Mounted Storage */
            mountedStorageLabel: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "MountedStorageTypeSelect.mountedStorageLabel?c=3u33x4vkk6k7d", defaultMessage: "Mounted Storage" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Description for storage type Mounted Storage */
            mountedStorageDescription: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "MountedStorageTypeSelect.mountedStorageDescription?c=3icc86lt0f7dj", defaultMessage: "Store this project in the cloud and stream to your desktop using Frame.io Drive" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Error message for upgrade issues */
            upgradeError: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "MountedStorageTypeSelect.upgradeError?c=n728a2qfhe28", defaultMessage: "Not enough Mounted Storage available. Free up space or add capacity to mount this project." }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
